module.exports = __webpack_public_path__ + "img/gxlogo2.5a55800b.png";